import * as React from "react";
import { casesActions } from "configs";
import { useDispatch, useOnline, useToast } from "duck";
import { useUpdateMedicalCaseMutation } from "requests";
import { SelectionContext } from "../../../../../../../duck";

export const useRenameCase = (onClose: () => void) => {
  const dispatch = useDispatch();

  const online = useOnline();

  const toast = useToast();
  const { selection, reset } = React.useContext(SelectionContext);
  const selectedCase = selection[0];
  const [update] = useUpdateMedicalCaseMutation();

  const onSuccess = () => {
    toast({
      status: "success",
      description: "Case is updated successfully."
    });
    reset();
    onClose();
  };

  return {
    onSubmit: (values: { name: string }) => {
      dispatch(
        casesActions.updateCaseName({
          _id: selectedCase._id,
          data: values.name
        })
      );

      if (online && selectedCase.offlineStatus !== "offline") {
        return update({
          variables: { input: { _id: selectedCase._id, name: values.name } }
        }).then(onSuccess);
      }

      onSuccess();
      return Promise.resolve();
    },
    initialName: selectedCase.name
  };
};
